<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13yE8yx/tc-custom/9781504009959.jpg?1698090299113" alt="This image is the cover for the book Cave Under the City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cave Under the City
      </h1>
      <p class="bookDescription body article font2">
        <b>Nobody said New York City was easy, but for Tolley Holtz, it’s home</b><br/><br/> Tolley Holtz would rather be exploring the city with his friends, talking about the Yankees, and discussing what President Roosevelt is going to do about the Depression than watching his little brother, Bubber. With his mother working all day in a garment factory and his father looking for work in Baltimore, Tolley’s family depends on him.<br/>  <br/> But suddenly, things go from hard to unthinkable. When his mother gets pneumonia and can’t leave the hospital, Tolley becomes the only family Bubber can rely on. Afraid that the children’s shelter will split them up, the two brothers hop a crosstown bus and strike out on their own, up and down fire escapes, across rooftops, and into the cellars and shadows of New York City. Tolley will need all the street smarts he’s ever learned to get them through the winter—and to hold on to his dreams of having a family again.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry Mazer
      </h2>
      
      <p class="authorDescription body article">Harry Mazer is the author of twenty-two novels for children and young adults. Best known for his acclaimed realistic teen fiction, Mazer has been recognized with the New York Library Association&rsquo;s Knickerbocker Award for Juvenile Literature and the ALAN Award for contributions to young adult literature, as well as several best-book designations from the American Library Association, among other honors.<BR /><BR /> After graduating from the Bronx High School of Science, Mazer joined the US Army Air Force, serving in World War II from 1943 to 1945 as a sergeant. He received a Purple Heart and an Air Medal after his B-17 bomber was shot down in 1945.&#160;Mazer&rsquo;s wartime experiences later inspired several of his novels, including the Boy at War series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb04fd8e